import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ButtonProps } from '@cp/ds/src/components/button';
import { FC } from 'react';
import { Favorite } from '../item/actions/favorite';
import { FavoriteVariant } from '../item/actions/favorite/model';

export const FavoriteFeature: FC<CatalogItemViewModel & { size?: ButtonProps['size'] }> = ({ clientProfile, size = 'less' }) => {
  if (!clientProfile) {
    return null;
  }
  return (
    <Favorite
      authorId={clientProfile.id}
      size={size}
      sx={{ width: { xs: '28px', md: '32px' }, height: { xs: '28px', md: '32px' } }}
      variant={FavoriteVariant.icon}
    />
  );
};
